import { IRootState } from '@/store/state';
import { GetterTree, Getter } from 'vuex';
import { PaginationMeta, SubFund, SubFundFilter } from '../types';
import { ISubFundState } from './state';

/**
 * --------------------------------------------------
 *	Organisation Getters
 * --------------------------------------------------
 **/
export const SubFundGetters: ISubFundGetters = {
  subFunds: (state: ISubFundState): SubFund[] => state.subFunds,
  subFundPaginationMeta: (state: ISubFundState): PaginationMeta =>
    state.subFundPaginationMeta,
  filterSubFundItems: (state: ISubFundState): SubFund[] => state.filterSubFunds,
  appliedSubFundFilters: (state: ISubFundState): SubFundFilter =>
    state.appliedFilters
};

/**
 * --------------------------------------------------
 *	Organisation Getters Interface
 * --------------------------------------------------
 **/
export interface ISubFundGetters extends GetterTree<ISubFundState, IRootState> {
  subFunds(state: ISubFundState): SubFund[];
  subFundPaginationMeta(state: ISubFundState): PaginationMeta;
  filterSubFundItems(state: ISubFundState): SubFund[];
  appliedSubFundFilters(state: ISubFundState): SubFundFilter;
}
